import Icon from 'common/Icon';
import styled from 'styled-components';

const StyledIcon = styled(Icon)`
    margin-left: 0.5em;
`;

export default StyledIcon;
